import Vue from 'vue'
import {checkLogin,checkIdType} from './network'
//自定义指令根据后端返回值判断元素显示状态
const pulicEl=(el,binding,vnode)=> {
    let permissions = checkLogin("permissionsV2");//v2字段
    sessionStorage.setItem('demo',JSON.stringify(permissions))
    let permissionRole = checkLogin("permissionDeniedStyle");//permissionDeniedStyle权限
    if(permissions == undefined) return false;//接口不返回不进行下面判断
    let permissionsInfo = el.getAttribute("permissionInfo");//获取el自定义属性
    if(el.getAttribute("nopermission") == "true")return;
    if(permissions[permissionsInfo] === undefined){//V2字段没有值全为0,0
       permissions[permissionsInfo] = [0,0] //hide
    }
    // console.log('dss',el,vnode)
    //如果元素为Element组件
    if(vnode.tag == "vue-component-28-ElButton"){
        //如果元素为Element按钮/text
        // if(vnode.elm.className == "el-button el-button--text" || vnode.elm.className == "el-button el-button--text el-button--small"|| vnode.elm.className == "el-button el-button--text el-button--medium" || vnode.elm.className== "el-button el-button--text is-disabled"){
        if(vnode.elm.className.indexOf('el-button--text') != -1){
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                if(permissionRole == 0) {
                    el.disabled = true;
                    el.style.color = "#c0ccda";
                }else if(permissionRole == 1){
                    el.style.display = "none"
                }
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 1){
                el.disabled = true;
                el.style.color = "#c0ccda";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 1){
                el.disabled = true;
                el.style.color = "#c0ccda";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 2){
                el.disabled = false;
            }
        }else{
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                if(permissionRole == 0) {
                    if (vnode.elm.className == "el-button _userClassInfo el-button--primary") {
                        el.style.display = "none";
                        return
                    }
                    el.disabled = true;
                    vnode.elm.className = "el-button el-button--default is-disabled add-time-btn"
                }else if(permissionRole == 1){
                    el.style.display = "none"
                }
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 1){
                el.disabled = true;
                vnode.elm.className = "el-button el-button--default is-disabled add-time-btn"
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 1){
                el.disabled = true;
                vnode.elm.className = "el-button el-button--default is-disabled add-time-btn"
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 2){
                el.disabled = false;
            }
        }   
        
    }else if(vnode.tag == "vue-component-24-ElSwitch"){
        // console.log(permissions[permissionsInfo])
        if(vnode.elm.className.indexOf('el-switch') != -1){
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                if(permissionRole == 0) {
                    el.disabled = true;
                    el.childNodes[0].setAttribute("_disabled","true")
                    el.style.color = "#c0ccda";
                }else if(permissionRole == 1){
                    el.style.display = "none"
                }
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 1){
                el.disabled = true;
                el.childNodes[0].setAttribute("_disabled","true")
                el.style.color = "#c0ccda";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 1){
               el.childNodes[0].setAttribute("_disabled","true")
            // el.firstChild.disabled = true;
            // el.style.color = "#c0ccda";
            // el.style.cursor = 'not-allowed'
            // el.style.opacity = '0.6'
            // el.style.display = "none"
                
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 2){
                el.disabled = false;
            }
        }
    }else{//标签元素类型
        if(vnode.elm.className.indexOf("menu_li") >= 0 && vnode.elm.className.indexOf("hidden") < 0){
            if (checkIdType("dealerLevel2")) {
                permissions['refundInfo'] = [2,0]
                permissions['wechatFeedbackInfo'] = [2,0]
                permissions['invoiceInfo'] = [2,0]
            }
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                if(el.getAttribute("ishide") == "true"){
                    el.style.display = "none";
                }else{
                    if(permissionRole == 0) {
                        vnode.elm.className = "menu_li is-disable"
                    }else if(permissionRole == 1){
                        el.style.display = "none"
                    }
                }
            }
            if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
               el.style.display = "none"
            }
            if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
               el.style.display = "none"
            }
        }else if(vnode.elm.className.indexOf("hidden") >= 0){
            if (checkIdType("dealerLevel2")) {
                permissions['refundInfo'] = [2,0]
                permissions['wechatFeedbackInfo'] = [2,0]
                permissions['invoiceInfo'] = [2,0]
            }
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                if(permissionRole == 0) {
                    el.style.display = "block"
                }else if(permissionRole == 1){
                    el.style.display = "none"
                }
            }
            if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
               el.style.display = "none"
            }
            if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
               el.style.display = "none"
            }
        }else if(vnode.tag == "div"){
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                if(permissionRole == 0) {
                    if(vnode.elm.className == "charging-info isEcharts"){
                       el.style.display = "none";
                       return
                    }
                    if (vnode.elm.className == "table userGradeInfo") {
                        el.style.display = "none";
                        return
                    }
                    if (vnode.elm.className == "_userClassInfo") {
                        el.style.display = "none";
                        return
                    }
                    if(vnode.elm.className == "coupon-info is-hide"){
                       el.style.display = "none";
                       return
                    }
                    el.style.display = "block"
                }else if(permissionRole == 1){
                    el.style.display = "none"
                }
                
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }
        }else{
            if(permissions[permissionsInfo][0] == 0 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 1 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }else if(permissions[permissionsInfo][0] == 2 && permissions[permissionsInfo][1] == 0){
                el.style.display = "none";
            }
        }
    }
};

const setPermission = Vue.directive('setPermission',{
  inserted (el,binding,vnode) {
    pulicEl(el,binding,vnode)
  },
  update (el,binding,vnode) {
    pulicEl(el,binding,vnode)
  }
})
export {setPermission}